module.exports = __webpack_public_path__ + "static/media/vip-hour-tile-free.33fb30ab.png";